export default __webpack_public_path__ + "static/media/step_3.ce4349f8.svg";